export default function ( title ) {
	window.gtag( 'event', title )
}